module.exports = __webpack_public_path__ + "static/media/18ECA11.40752ca2.jpg";